import * as React from 'react';
import './styles.scss';
import { FC } from 'react';
import { ClientEntity, ProfessionalEntity } from "../../store/entities/state";
import { FilesAndResportsList } from '../../components/FilesAndReportsList';

export interface ClientReportsTableProps {
    isOpen?: boolean,
    client: ClientEntity;
    professional?: ProfessionalEntity;
}

const ClientReportsTable : FC<ClientReportsTableProps> = ({isOpen, client}) => {

    return (
        <>
            <FilesAndResportsList clientId={client.id} />
        </>
    );
}

export default ClientReportsTable;